import DocumentUploadingIcon from './DocumentUploadingIcon'

export default DocumentUploadingIcon
